import React, { useEffect } from 'react';
import { MapContainer, TileLayer, Marker, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Volt teardrop marker (avoids the broken default-icon webpack issue).
const voltIcon = L.divIcon({
  className: '',
  html: `<div style="width:22px;height:22px;border-radius:50% 50% 50% 0;background:#C23A00;border:2px solid #fff;transform:rotate(-45deg);box-shadow:0 2px 6px rgba(0,0,0,0.35)"></div>`,
  iconSize: [22, 22],
  iconAnchor: [11, 22],
});

const Recenter = ({ lat, lng }) => {
  const map = useMap();
  useEffect(() => { map.setView([lat, lng], map.getZoom()); }, [lat, lng, map]);
  return null;
};

const LocateMap = ({ lat, lng }) => (
  <MapContainer
    center={[lat, lng]}
    zoom={15}
    scrollWheelZoom={false}
    style={{ height: '100%', width: '100%' }}
    attributionControl={false}
  >
    <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
    <Marker position={[lat, lng]} icon={voltIcon} />
    <Recenter lat={lat} lng={lng} />
  </MapContainer>
);

export default LocateMap;
